import { useContext } from "react";
import style from "./style.less";
import HomeHeaderOther from "@/components/HomeHeader/indexOther";
import MyNavLink from "@/components/MyNavLink";
import { LanguageContext } from "@/data/LanguageProvider";
import { LocalConfig } from "@/config";

const Contact = () => {
  const { langText } = useContext(LanguageContext);

  return (
    <div class={style.page_container}>
      <HomeHeaderOther title={langText("profile_btn_5")} />
      <div class={style.contact_content}>
        <div class={style.contact_content_div}>
          <img
            src={require("@/assets/images/home/kftb_1.png").default}
            style={{ width: "2.5rem", marginTop: "0.8rem", marginLeft: "1.5rem", marginBottom: "0.8rem" }}
          />
          <MyNavLink
            to="/contact"
            style={{ textDecoration: "underline", marginLeft: "0.5rem" }}
          >
            Contact Us
          </MyNavLink>
        </div>

        <div class={style.footer_common}>
          <img src={require("@/assets/images/home/18_plus.png").default} />
          <span>
            <span class={style.symbol}>©</span> {LocalConfig.gameName} {langText("common_tips_1")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default Contact;
